import type { DemoKey } from './keys';

export const fr: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Géométrie · 3D',
  'panel.figure': 'Figure',
  'panel.dims': 'Dimensions',
  'panel.style': 'Apparence',
  'panel.lines': 'Lignes spéciales',
  'style.body': 'Corps',
  'style.line': 'Ligne',
  'style.cut': 'Section',
  'style.labels': 'Étiquettes des sommets',
  'group.face': 'Diagonales des faces / génératrices',
  'group.space': 'Diagonales / axes / médianes',
  'split.label': 'Section',
  'btn.animate': 'Animer',
  'btn.reset': 'Réinitialiser',
  'hint.line1': 'Glissez pour pivoter · Défilez pour zoomer',
  'hint.line2': 'Cliquez sur une ligne pour la sélectionner',
  'fig.cuboid': 'Parallélépipède',
  'fig.cube': 'Cube',
  'fig.triPrism': 'Prisme triangulaire',
  'fig.hexPrism': 'Prisme hexagonal',
  'fig.tetrahedron': 'Tétraèdre',
  'fig.squarePyramid': 'Pyramide carrée',
  'fig.cylinder': 'Cylindre',
  'fig.cone': 'Cône',
  'fig.sphere': 'Sphère',
  'fig.frustumPyramid': 'Tronc de pyramide',
  'fig.frustumCone': 'Tronc de cône',
  'dim.length': 'longueur',
  'dim.width': 'largeur',
  'dim.height': 'hauteur',
  'dim.side': 'côté',
  'dim.radius': 'rayon',
  'dim.r1': 'rayon bas',
  'dim.r2': 'rayon haut',
  'dim.sideBase': 'côté base',
  'dim.sideTop': 'côté haut',
  'info.face': 'face',
  'info.center': 'par le centre',
  'info.diagonal': 'diagonale',
  'info.axial': 'diagonale axiale',
  'info.diameter': 'diamètre',
  'info.generator': 'génératrice',
  'info.axis': 'axe',
  'info.height': 'hauteur',
  'info.median': 'médiane',
  'info.apothem': 'apothème',
  'info.diameterBase': 'diamètre base',
  'info.diameterTop': 'diamètre haut',
};
